import Vue from 'vue';
import Router from 'vue-router';

import Home from './views/login/Login.vue';
Vue.use(Router);

const Login = (resolve) => {
  require.ensure(['./views/login/Login.vue'], () => {
    resolve(require('./views/login/Login.vue'));
  }, 'login');
};
const Dashboard = (resolve) => {
  require.ensure(['./views/dashboard/Dashboard.vue'], () => {
    resolve(require('./views/dashboard/Dashboard.vue'));
  }, 'dashboard');
};
const Comercial = (resolve) => {
  require.ensure(['./views/tableros/comercial/Comercial.vue'], () => {
    resolve(require('./views/tableros/comercial/Comercial.vue'));
  }, 'comercial');
};
const Operaciones = (resolve) => {
  require.ensure(['./views/tableros/operaciones/Operaciones.vue'], () => {
    resolve(require('./views/tableros/operaciones/Operaciones.vue'));
  }, 'operaciones');
};
const Mantenimineto = (resolve) => {
  require.ensure(['./views/tableros/operaciones/Mantenimiento.vue'], () => {
    resolve(require('./views/tableros/operaciones/Mantenimiento.vue'));
  }, 'mantenimiento');
};
const DetalleIndicador = (resolve) => {
  require.ensure(['./views/tableros/commun/DetalleIndicador.vue'], () => {
    resolve(require('./views/tableros/commun/DetalleIndicador.vue'));
  }, 'detalle-indicador');
};
const Metas = (resolve) => {
  require.ensure(['./views/metas/Metas.vue'], () => {
    resolve(require('./views/metas/Metas.vue'));
  }, 'metas');
};

const AddUser = (resolve) => {
  require.ensure(['./views/users/AddUser.vue'], () => {
    resolve(require('./views/users/AddUser.vue'));
  }, 'add-user');
};
const Users = (resolve) => {
  require.ensure(['./views/users/Users.vue'], () => {
    resolve(require('./views/users/Users.vue'));
  }, 'users');
};
const OcupacionDirectivo = (resolve) => {
  require.ensure(['./views/reportes/Ocupacion.vue'], () => {
    resolve(require('./views/reportes/Ocupacion.vue'));
  }, 'ocupacion');
};
const OcupacionFamilia = (resolve) => {
  require.ensure(['./views/reportes/OcupacionFamilia.vue'], () => {
    resolve(require('./views/reportes/OcupacionFamilia.vue'));
  }, 'ocupacion-familia');
};

const OcupacionFinanciera = (resolve) => {
  require.ensure(['./views/reportes/OcupacionFinanciera.vue'], () => {
    resolve(require('./views/reportes/OcupacionFinanciera.vue'));
  }, 'ocupacion-financiera');
};

const CobranzaMes = (resolve) => {
  require.ensure(['./views/reportes/CobranzaMes.vue'], () => {
    resolve(require('./views/reportes/CobranzaMes.vue'));
  }, 'cobranza-mes');
};
const NotFound = (resolve) => {
  require.ensure(['./views/404.vue'], () => {
    resolve(require('./views/404.vue'));
  }, 'not-found');
};

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes:[
    {
      path: '',
      components: {
        default: Dashboard,
        login: Login,
      },
    },
    { path: '/tablero-comercial/comercial', component: Comercial },
    { path: '/tablero-operaciones/operaciones', component: Operaciones },
    { path: '/tablero-operaciones/mantenimiento', component: Mantenimineto },
  
    { path: '/monitoreo', component: DetalleIndicador },
    { path: '/reportes-directivos/ocupacion', component: OcupacionDirectivo },
    { path: '/reportes-directivos/ocupacion-familia', component: OcupacionFamilia },
    { path: '/reportes-directivos/ocupacion-financiera', component: OcupacionFinanciera },
    { path: '/reportes-directivos/cobranza-mes', component: CobranzaMes },
  
    { path: '/metas', component: Metas },
    { path: '/users', component: Users },
    { path: '/users/add', component: AddUser },
    {
      path: '/users/:id',
      name: 'user-edit',
      component: AddUser,
      beforeEnter: (to, from, next) => {
        // ... permission check
        next();
      },
    },
  
    { path: '/404', component: NotFound },
    { path: '*', redirect: '/404' },
  ],
});